export default {
    name: "AssetLibraryStatsWidget",
    type: "MultiDisplayWidget",
    description: "Quick counts of your asset library content.",
    roles: ["appUser"],
    widget: {
        title: "Asset Library",
        size: "medium",
        dataProvider: {
            main: {
                rpc: "AssetGenerationRpc.getAssetStats"
            }
        },
        items: [
            { label: "Characters", valueField: "characters", icon: "bi bi-person-video3" },
            { label: "Environments", valueField: "environments", icon: "bi bi-image" },
            { label: "Props", valueField: "props", icon: "bi bi-box" },
            { label: "Total Assets", valueField: "total", icon: "bi bi-collection-fill" }
        ]
    }
};